import {
  CLAIMS_RI_RECOVERIES_INIT_LOADING,
  CLAIMS_RI_RECOVERIES_INIT_SUCCESS,
  CLAIMS_RI_RECOVERIES_INIT_FAIL
} from '@/store/types'

export const clmRIRcvy = {
  [CLAIMS_RI_RECOVERIES_INIT_LOADING](state) {
    state.clmRIRcvy.init = 0
    state.clmRIRcvy.initErr = []
    state.clmRIRcvy.menu = {}
  },
  [CLAIMS_RI_RECOVERIES_INIT_SUCCESS](state, data) {
    state.clmRIRcvy.init = 1
    state.clmRIRcvy.initErr = []
    state.clmRIRcvy.menu = data.menu
  },
  [CLAIMS_RI_RECOVERIES_INIT_FAIL](state, error) {
    state.clmRIRcvy.init = 2
    state.clmRIRcvy.initErr = error
    state.clmRIRcvy.menu = {}
  }
}
